<template>
  <div class="markets">
    <header-box :title="title" :intro="intro"></header-box>
    <div class="markets__innerwrap">
      <div class="markets__blocks">
        <market-block v-for="(block, index) in contentBlocks" :block="block" :key="index"/>
      </div>

      <div class="markets__blocks markets__blocks--mobile">
        <market-block v-for="(block, index) in mobileContentBlocks" :block="block" :key="index"/>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PrevNextNav from '@/components/PrevNextNav';
import HeaderBox from '@/components/HeaderBox';
import MarketBlock from '@/components/MarketBlock';

export default {
  name: 'markets',
  components: { PrevNextNav, HeaderBox, MarketBlock },
  data() {
    return {
      innerWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters(['page']),
    title() {
      return this.page.title;
    },
    intro() {
      return this.page.intro;
    },
    contentBlocks() {
      return this.page.contentBlocks;
    },
    mobileContentBlocks() {
      const contentBlocks = this.page.contentBlocks.slice();

      [].forEach.call(contentBlocks, (contentBlock, index) => {
        if (index % 2 === 1 && contentBlocks[index].type === 'image' && contentBlocks[index - 1].type === 'text') {
          const tempFirst = contentBlocks[index];
          const tempSec = contentBlocks[index - 1];
          contentBlocks[index] = tempSec;
          contentBlocks[index - 1] = tempFirst;
        }
      });

      return contentBlocks;
    },
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.innerWidth = window.innerWidth;
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../scss/helpers';

.markets {
  @include page(false);

  &__blocks {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    box-sizing: border-box;
    padding: 20px 0 0;

    @include mobile {
      display: none;

      &--mobile {
        display: block;
      }
    }


    @include not-mobile {
      padding: 40px 0;

      &--mobile {
        display: none;
      }
    }
    
    @include landscape {
      display: flex;
      padding: 20px 0 0;

      &--mobile {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/Markets.vue